// @flow
import connectWebActions from 'fg-frontend/src/webComponents/connectWebActions';
import { connectWebComponents } from 'fg-frontend/src/webComponents/decorate';
import autoTitleLinksWithBlankTarget from 'fg-frontend/src/components/autoTitleLinksWithBlankTarget';
import safeBlankLinks from 'fg-frontend/src/components/safeBlankLinks';
import phoneLink from 'fg-frontend/components/PhoneLink';
// import cookiesPolicy from 'fg-frontend/components/CookiesPolicy/index';
import cookiesPolicy from './components/CookiesPolicy/index';

import configureWebComponents from './configureWebComponents';
import configureWebActions from './configureWebActions';
import 'fg-frontend/ramjet/liveValidation';
// import 'bootstrap/collapse'; TODO - use this path if using BS4 bootstrap/js/dist/collapse
import menuScroll from './components/menuScroll';
import customHighslide from './components/customHighslide';
import gm from './components/jquery.gm.conf';

connectWebComponents(configureWebComponents);
connectWebActions(configureWebActions, ['keyup']);
autoTitleLinksWithBlankTarget();
cookiesPolicy({
  enableTechnicalButton: true,
});

phoneLink();
menuScroll();
customHighslide();
gm();

// Mastaveni atributu 'noopener' vsem target="_blank" odkazum, ktere ho nemaji
safeBlankLinks();



// WEBPACK FOOTER //
// ./fe/web-default/src/js/configureWeb.js